import { compareWithAppVersion, getAppVersion, isAndroid, isDev, isIOS } from '@croquiscom-pvt/web2app';

import { getConfig } from '@common/config';
import { isZigzag } from '@common/device-manager';

const config = getConfig();

export const isPDPVersion = (userAgent: string) => {
  if (isDev()) {
    return true;
  }

  if (!getAppVersion(userAgent)) {
    return true;
  }
  return (
    Boolean(compareWithAppVersion('6.42.0', userAgent) && isIOS(userAgent)) ||
    Boolean(compareWithAppVersion('6.42.0', userAgent) && isAndroid(userAgent))
  );
};

export const isPhotoReviewVersion = (userAgent: string) => {
  if (isDev()) {
    return true;
  }
  return (
    Boolean(compareWithAppVersion('6.84.0', userAgent) && isIOS(userAgent)) ||
    Boolean(compareWithAppVersion('6.84.0', userAgent) && isAndroid(userAgent))
  );
};

export const isQuickRatingVersion = () => {
  if (isDev() || !isZigzag()) {
    return true;
  }

  const isProd = config.stage === 'production' || process.env.NEXT_PUBLIC_DEPLOY_STAGE === 'production';
  const quickRatingAppVersion = isProd ? '7.73.0' : '7.71.0';
  return (
    Boolean(compareWithAppVersion(quickRatingAppVersion) && isIOS()) ||
    Boolean(compareWithAppVersion(quickRatingAppVersion) && isAndroid())
  );
};

export const isSavedProductsNotiVersion = () => {
  if (isDev() || !isZigzag()) {
    return true;
  }
  const savedProductsNotiAppVersion = '7.85.0';
  return (
    Boolean(compareWithAppVersion(savedProductsNotiAppVersion) && isIOS()) ||
    Boolean(compareWithAppVersion(savedProductsNotiAppVersion) && isAndroid())
  );
};

export const isExternalReviewVersion = () => {
  if (!isZigzag()) {
    return true;
  }
  const availableExternalReviewAppVersion = '7.92.0';
  return (
    Boolean(compareWithAppVersion(availableExternalReviewAppVersion) && isIOS()) ||
    Boolean(compareWithAppVersion(availableExternalReviewAppVersion) && isAndroid())
  );
};

export const isExperienceGroupDetailReviewVersion = () => {
  if (!isZigzag()) {
    return true;
  }

  const ExperienceGroupDetailReviewAppVersion = '7.95.0';
  return (
    Boolean(compareWithAppVersion(ExperienceGroupDetailReviewAppVersion) && isIOS()) ||
    Boolean(compareWithAppVersion(ExperienceGroupDetailReviewAppVersion) && isAndroid())
  );
};

export const isPredictionSummaryReviewAppVersion = () => {
  if (!isZigzag()) {
    return false;
  }

  const predictionSummaryReviewAppVersion = '8.11.0';
  return (
    Boolean(compareWithAppVersion(predictionSummaryReviewAppVersion) && isIOS()) ||
    Boolean(compareWithAppVersion(predictionSummaryReviewAppVersion) && isAndroid())
  );
};

export const isDeviceNotificationRefreshAppVersion = () => {
  if (!isZigzag()) {
    return false;
  }

  const deviceNotificationRefreshAppVersion = '8.28.0';
  return (
    Boolean(compareWithAppVersion(deviceNotificationRefreshAppVersion) && isIOS()) ||
    Boolean(compareWithAppVersion(deviceNotificationRefreshAppVersion) && isAndroid())
  );
};
